import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=0fbe8aad&scoped=true&"
import script from "./FormError.vue?vue&type=script&lang=js&"
export * from "./FormError.vue?vue&type=script&lang=js&"
import style0 from "./FormError.vue?vue&type=style&index=0&id=0fbe8aad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe8aad",
  null
  
)

/* custom blocks */
import block0 from "./FormError.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard,VCardText})
